import React from 'react';
import { imgUrlConverter } from "../../util";

export const PdfComponent = React.memo(({content}) => {
	const onButtonClick = () => {
		// using Java Script method to get PDF file
		let docUrl = window.location.origin + content.docUrl;
		fetch(docUrl).then((response) => {
			response.blob().then((blob) => {
				// Creating new object of PDF file
				const fileURL = window.URL.createObjectURL(blob);
				// Setting various property values
				let alink = document.createElement('a');
				alink.href = fileURL;
				alink.download = content.docName;
				alink.click();
			});
		});
	};

	if (content && Object.keys(content)?.length > 0) {
		return (
			<>
				<div className='row pdf-wrapper'>
					<div className='image-wrapper col-md-2 col-lg-2 col-sm-12'>
						<img src={imgUrlConverter(content.imageUrl)} alt="pdf image" height="75px" width="75px" />
						<span>{content.heading} </span>
					</div>
					<div className='text-wrapper col-md-6 col-lg-6 col-sm-12'>
						<span>{content.heading} </span>
						<p>
							{content.displayText}
						</p>
					</div>
					<div className='button-wrapper col-md-4 col-lg-4 col-sm-12'>
						<button onClick={onButtonClick}>DOWNLOAD PDF</button>
					</div>
				</div>
			</>
		);
	} else {
		return null
	}
});
